import { api, setConfig } from '../..';
import { PropertyType } from '../../../common';

export const getPermissionGroups = (data: PropertyType): Promise<PropertyType> =>
	api.get('/permissions/groups', setConfig(data)).then((res) => {
		return res.data;
	});
